import { render, staticRenderFns } from "./WorkIconMoveProject.vue?vue&type=template&id=59c619e6"
import script from "./WorkIconMoveProject.vue?vue&type=script&lang=js"
export * from "./WorkIconMoveProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports